import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteUserAccount } from '../../../api/auth';
import Modal from 'react-bootstrap/Modal';
import { useAuthStore } from '../../../store/store';

export const DeleteUserModal = () => {
    const { user, setUser, setIsAuth } = useAuthStore(store => store);
    const [showModal, setShowModal] = useState(false);
    const [showCredentials, setShowCredentials] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();

    const handleRedirect = () => {
        setErrorMessage('');
        closeModal();
        setUser(null);
        setIsAuth(false);
        navigate('/');
    };

    const closeModal = () => {
        setErrorMessage('');
        setShowModal(false);
        setShowCredentials(false);
    };

    const handleChange = (e) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleConfirm = () => {
        if (user.providerData[0].providerId === 'password') {
            // Email & Password Account
            setShowCredentials(true);
        } else {
            // Google Account
            handleDeleteAccountByGoogle();
        }
    };

    const handleDeleteAccountByPassword = async e => {
        e.preventDefault();
        try {
            await deleteUserAccount(formData.email, formData.password);
            handleRedirect();
        } catch (error) {
            if (error.code === 'auth/too-many-requests') {
                setErrorMessage('Too many unsuccessful attempts. Please try again later.');
            } else {
                setErrorMessage('Incorrect email or password. Please try again.');
            }
        }
    };

    const handleDeleteAccountByGoogle = async() => {
        await deleteUserAccount();
        handleRedirect();
    };

    // function that returns two buttons (cancel and confirm)
    const renderButtons = (onCancel, onConfirm) => {
        return (
            <div className='d-flex justify-content-around gap-5 w-100 my-4'>
                <button className='user-delete-cancel py-2 px-3' onClick={onCancel}>Cancel</button>
                <button className='user-delete-confirm py-2 px-3' onClick={onConfirm}>Confirm</button>
            </div>
        );
    };

    return (
        <>
            <div className='row'>
                <div className='col-12 d-flex justify-content-center'>
                    <button type='button' className='delete-user-btn bg-deleteBtnColor' onClick={() => setShowModal(true)}>DELETE ACCOUNT</button>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='w-100 text-center p-2'>
                        Delete Account Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-column justify-content-center align-items-center p-3'>
                        {!showCredentials
                            ? (
                                <>
                                    <p className="text-center mb-2">
                                        <strong>Warning: </strong>Deleting your account is irreversible and will
                                        result in the loss of all your data and access to this platform. Are you
                                        sure you want to proceed?
                                    </p>
                                    {renderButtons(closeModal, handleConfirm)}
                                </>
                            )
                            : (
                                <>
                                    <p className='text-left mb-4'>Please Please re-enter your credentials to proceed with account deletion.</p>
                                    <div className='d-flex flex-column gap-3 w-100'>
                                        <input
                                            className='form-control'
                                            type='email'
                                            placeholder='Email Address'
                                            name='email'
                                            onChange={handleChange}
                                            required
                                        />
                                        <input
                                            className='form-control'
                                            type='password'
                                            placeholder='Password'
                                            name='password'
                                            onChange={handleChange}
                                            required
                                        />
                                        {errorMessage && <p className='text-red-500'>{errorMessage}</p>}
                                    </div>
                                    {renderButtons(closeModal, handleDeleteAccountByPassword)}
                                </>
                            )
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
